export const gameVersions = [
  'live',
  'classic_era',
  'classic_progression',
  'season_of_discovery',
] as const

export const gameVersionToSubdomain = {
  live: '',
  classic_era: 'vanilla.',
  classic_progression: 'classic.',
} as const

type GameVersion = typeof gameVersions[number]
export default GameVersion
